module.exports = __webpack_public_path__ + "img/green-water.431878a8.svg";